import _extends from "@babel/runtime-corejs3/helpers/extends";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
var _excluded = ["contextSwitcher", "renderContextSwitcher", "className", "renderCustomComponent"];
import React, { memo } from "react";
import cx from "classnames";
import { SubApplicationHeader } from "@jutro/router";
import { resolveProps } from "@jutro/uiconfig";
import styles from "./AppFloorPlan.module.css";
var AppFloorPlanSubHeaderInternal = function AppFloorPlanSubHeaderInternal(_ref) {
  var _ref$subHeaderProps = _ref.subHeaderProps,
    subHeaderProps = void 0 === _ref$subHeaderProps ? {} : _ref$subHeaderProps,
    visibleRoutes = _ref.visibleRoutes,
    callbackMap = _ref.callbackMap,
    _ref2 = resolveProps(subHeaderProps, callbackMap, {}),
    subHeaderContextSwitcher = _ref2.contextSwitcher,
    renderContextSwitcher = _ref2.renderContextSwitcher,
    subHeaderClassName = _ref2.className,
    renderCustomComponent = _ref2.renderCustomComponent,
    otherSubHeaderProps = _objectWithoutProperties(_ref2, _excluded);
  return React.createElement(SubApplicationHeader, _extends({
    navigationRoutes: visibleRoutes,
    contextSwitcher: subHeaderContextSwitcher,
    renderContextSwitcher: renderContextSwitcher,
    renderCustomComponent: renderCustomComponent
  }, otherSubHeaderProps, {
    className: cx(subHeaderClassName, styles.subHeader)
  }));
};
AppFloorPlanSubHeaderInternal.displayName = "AppFloorPlanSubHeader";
export var AppFloorPlanSubHeader = memo(AppFloorPlanSubHeaderInternal);
AppFloorPlanSubHeaderInternal.__docgenInfo = {
  description: "",
  methods: [],
  displayName: "AppFloorPlanSubHeader",
  props: {
    subHeaderProps: {
      defaultValue: {
        value: "{}",
        computed: !1
      },
      required: !1
    }
  }
}, AppFloorPlanSubHeaderInternal.__docgenInfo = {
  componentName: "AppFloorPlanSubHeader",
  packageName: "@jutro/floorplan",
  description: "",
  displayName: "AppFloorPlanSubHeader",
  methods: [],
  actualName: "AppFloorPlanSubHeaderInternal",
  props: {
    subHeaderProps: {
      defaultValue: {
        value: "{}",
        computed: !1
      },
      required: !1
    }
  }
};